import { ApiResult, CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AtributoReceitaEntity } from "@catalogo/models";
import { CONFIGURACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'any' })
export class AtributoReceitaDataService extends CrudService<AtributoReceitaEntity> {
    protected url: string;

    constructor(
        @Inject(CONFIGURACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/atributoreceita`;
    }

    public obterPorCodigoPortalUnico(codigoAtributoPortalUnico: string) {
        return this.httpClient.get<ApiResult<AtributoReceitaEntity>>(this.url + `/codigo/${codigoAtributoPortalUnico}`);
    }

    public obterPorId(atributoReceitaId: string){
        return this.httpClient.get<ApiResult<AtributoReceitaEntity>>(this.url + `/${atributoReceitaId}`);
    }
}
